(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
if (document.getElementsByTagName('cart-drawer').length > 0) {

  document.body.addEventListener('docapp-discount-applied', (e) => { 
    // Set the total cart value after the discount code is applied so the sample can check if the minimum amount is met
    const cartSampleElement = document.querySelector('.cart-sample .cart-gwp');
    const cartTotalPrice = e.estimatedTotal / 100;
    const cartTotalShipping = e.shippingTotal / 100;
    const cartSubTotalPrice = cartTotalPrice - cartTotalShipping;
    
    if (cartSampleElement) {
      cartSampleElement.setAttribute("data-cart-total", cartSubTotalPrice.toFixed(2));
    }

    // Hide/show the promo code
    theme.waitForElement('.docapp-coupon-input', 300).then(() => {
      const hasManualDiscount = e.discounts.some(obj => obj.type == 'manual');
      const hasDiscountError = document.querySelector('.docapp-coupon-input--message-container.docapp-hide') == null;
      if (hasManualDiscount || hasDiscountError) {
        document.querySelector('.show-promo-code a').click();
      } else {
        document.querySelector('.show-promo-code').classList.remove('visually-hidden');
        document.querySelector('.docapp-coupon-input').removeAttribute("style");
      }
    }).catch(e => {
      console.log('Element(s) with ".docapp-coupon-input" identifiers not found!');
    });
  
    // Wrap the subtotal and shipping fields to expand/contract
    // Check if the breakdown wrapper already exists
    if (document.querySelector('.docapp-breakdown') === null) {
        // Only query for this element once and reuse the variable
        const estTotalElem = document.querySelector('.docapp-est-total');
        if (!estTotalElem) return; // Early exit if the element doesn't exist
    
        let prevSiblings = [];
        let elem = estTotalElem;
    
        // Collect all previous siblings in one traversal
        while (elem = elem.previousElementSibling) {
            prevSiblings.push(elem);
        }
    
        // Reverse the order of siblings to maintain the original order as they were collected in reverse
        prevSiblings.reverse();
    
        // Create the wrapper div and the container within it
        const breakdownDiv = document.createElement('div');
        breakdownDiv.classList.add('docapp-breakdown', 'toggle-target', 'toggle-target--hidden');
        const containerDiv = document.createElement('div');
        containerDiv.classList.add('toggle-target-container');
    
        // Append all siblings to the container in one batch
        prevSiblings.forEach(sibling => containerDiv.appendChild(sibling));
    
        // Append the container to the breakdown wrapper
        breakdownDiv.appendChild(containerDiv);
    
        // Insert the entire structure before 'estTotalElem' in one operation
        estTotalElem.parentNode.insertBefore(breakdownDiv, estTotalElem);
    
        // Add class to 'show-breakdown-btn', assuming this element exists and needs to be modified
        const showBreakdownBtn = document.querySelector('.show-breakdown-btn');
        if (showBreakdownBtn) {
            showBreakdownBtn.classList.add('toggle-target-toggler--is-hidden');
        }
    }

    /** Combining discounts */
    if (event.discounts && event.discounts.length) {
      const discountCodes = window.theme.settings.combined_discount_codes;

      // Loop through each requiredCode and corresponding additionalCode in the discountCodes JSON
      for (const requiredCode in discountCodes) {
        const additionalCode = discountCodes[requiredCode];

        // Check if the requiredCode is applied by looking through event.discounts
        const requiredCodeApplied = event.discounts.some(discount => discount.title.toUpperCase() === requiredCode.toUpperCase());

        // Check if the additionalCode is already applied
        const additionalCodeExists = event.discounts.some(discount => discount.title.toUpperCase() === additionalCode.toUpperCase());
        
        if (requiredCodeApplied) {
          // Apply the additionalCode if it's not already applied
          if (!additionalCodeExists) {
            window.discountOnCartProApp.applyCode(additionalCode);
          }
        }
        else {
          // If the requiredCode is not applied, check if the additionalCode is applied and remove it          
          if (additionalCodeExists) {
            window.discountOnCartProApp.removeCode(additionalCode);
          }
        }
      }
    }
  });

  document.body.addEventListener('docapp-discount-success', (e) => { 
    // refresh the cart page via ajax
    document.dispatchEvent(
      new CustomEvent('on:cart:change', { bubbles: true, cancelable: false }));
  });
  
  // Show promo code input
  document.querySelector('.show-promo-code a').addEventListener('click', function(e) {
    e.preventDefault();
  
    // Add the 'visually-hidden' class to the parent with the class 'show-promo-code'
    this.parentNode.classList.add('visually-hidden');
    
    // Select the element and change its CSS property
    const couponInput = document.querySelector('.docapp-coupon-input');
    couponInput.style.maxHeight = 'none';
    couponInput.classList.add('docapp-coupon-input--visible');
  
    // Focus the input element
    couponInput.querySelector('.docapp-coupon-input--input').focus();
  });
  
  
  document.body.addEventListener('docapp-shipping-rate-chosen', (e) => {

      // Update the estimated delivery date based on shipping country
      document.querySelector('delivery-date')?.setAttribute('data-country', document.querySelector('.docapp-country-input select').value);
    
      // Hide/show the appropriate shipping bar
      var noShippingRates = document.querySelector('.docapp-shipping-calculator--rates.docapp-hide, .docapp-no-rates') !== null;
      document.querySelector('.docapp-shipping-bar').classList.toggle('visually-hidden', noShippingRates);
      document.querySelector('.docapp-calculate-shipping-bar').classList.toggle('visually-hidden', !noShippingRates);
  
      // Wrap the subtotal and shipping fields to expand/contract
      // Check if the breakdown wrapper already exists
      if (document.querySelector('.docapp-breakdown') === null) {
          // Only query for this element once and reuse the variable
          const estTotalElem = document.querySelector('.docapp-est-total');
          if (!estTotalElem) return; // Early exit if the element doesn't exist
      
          let prevSiblings = [];
          let elem = estTotalElem;
      
          // Collect all previous siblings in one traversal
          while (elem = elem.previousElementSibling) {
              prevSiblings.push(elem);
          }
      
          // Reverse the order of siblings to maintain the original order as they were collected in reverse
          prevSiblings.reverse();
      
          // Create the wrapper div and the container within it
          const breakdownDiv = document.createElement('div');
          breakdownDiv.classList.add('docapp-breakdown', 'toggle-target', 'toggle-target--hidden');
          const containerDiv = document.createElement('div');
          containerDiv.classList.add('toggle-target-container');
      
          // Append all siblings to the container in one batch
          prevSiblings.forEach(sibling => containerDiv.appendChild(sibling));
      
          // Append the container to the breakdown wrapper
          breakdownDiv.appendChild(containerDiv);
      
          // Insert the entire structure before 'estTotalElem' in one operation
          estTotalElem.parentNode.insertBefore(breakdownDiv, estTotalElem);
      
          // Add class to 'show-breakdown-btn', assuming this element exists and needs to be modified
          const showBreakdownBtn = document.querySelector('.show-breakdown-btn');
          if (showBreakdownBtn) {
              showBreakdownBtn.classList.add('toggle-target-toggler--is-hidden');
          }
      }
  });
  
  // Sync all expand/contract togglers state (applicable to estimate shipping toggler)
  document.querySelectorAll('toggle-target[data-toggle-target=".docapp-breakdown"]').forEach((el) => {
    el.addEventListener('click', (e) => {
      const togglerAnchors = document.querySelectorAll('toggle-target[data-toggle-target=".docapp-breakdown"]');
      const shouldHide = e.currentTarget.classList.contains('toggle-target-toggler--is-hidden');
  
      togglerAnchors.forEach(anchor => {
        if (anchor !== e.currentTarget) {
            anchor.classList.toggle('toggle-target-toggler--is-hidden', shouldHide);
        }
      });
    });
  });

  // Update the cart item count when free gift is removed from the cart
  document.body.addEventListener('docapp-free-gift-cart-change', (e) => { 
    document.dispatchEvent(
      new CustomEvent('on:cart:change', { bubbles: true, cancelable: false })
    );
  });

}

  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class MobileDisclosure extends DetailsDisclosure {
      constructor() {
        super();

        const collapseEnabled = this.dataset.collapse === 'true';
        if (!collapseEnabled) return;

        this.reset();
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
          this.querySelectorAll('.disclosure, .disclosure__title, .disclosure__panel, .disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(`mobile-${cl}`);
            });
          });
        } else {
          this.toggle.removeAttribute('tabindex');
          this.querySelectorAll('.mobile-disclosure, .mobile-disclosure__title, .mobile-disclosure__panel, .mobile-disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('mobile-disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(cl.substr(7));
            });
          });
        }
      }
    }

    customElements.define('mobile-disclosure', MobileDisclosure);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
document.body.addEventListener('docapp-discount-applied', (e) => {
  // Set the total cart value after the discount code is applied so the sample can check if the minimum amount is met
  let cartSampleElement = document.querySelector('.cart-sample .cart-gwp');
  let cartTotalPrice = e.estimatedTotal / 100;
  let cartTotalShipping = e.shippingTotal / 100;
  let cartSubTotalPrice = cartTotalPrice - cartTotalShipping;

  if (cartSampleElement) {
    cartSampleElement.setAttribute("data-cart-total", cartSubTotalPrice.toFixed(2));
  }
});

document.body.addEventListener('docapp-discount-success', (e) => { 
  // refresh the cart page via ajax
  document.dispatchEvent(
    new CustomEvent('on:cart:change', { bubbles: true, cancelable: false }));
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-contact"]) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  const extractedForms = new Set();
  
  // Extract form titles from form headers
  function extractFormTitles() {
    const forms = document.querySelectorAll('.form-container .contact-form');
    const desktopTabs = document.querySelectorAll('.form-selector [data-form-tab]');
    const mobileOptions = document.querySelectorAll('.mobile-form-selector [data-form-tab]');
    
    forms.forEach((form, index) => {
      const desktopTab = desktopTabs[index];
      const mobileOption = mobileOptions[index];
      
      if (!desktopTab || !mobileOption) return;
      
      // Skip if already extracted
      if (extractedForms.has(index)) return;
            
      // Try to find the form title - check for Shadow DOM
      let paragraph = null;
      const shopifyFormsEmbed = form.querySelector('shopify-forms-embed');
      
      if (shopifyFormsEmbed && shopifyFormsEmbed.shadowRoot) {
        // Access Shadow DOM content
        paragraph = shopifyFormsEmbed.shadowRoot.querySelector('[class*="_formHeader"] [class*="_textBody"] p');
      } else {
        // Fallback to regular DOM query
        paragraph = form.querySelector('[class*="_formHeader"] [class*="_textBody"] p');
      }
      
      if (paragraph) {
        // Extract HTML content to preserve styling like <strong>
        const titleHTML = paragraph.innerHTML.trim();
        const titleText = paragraph.textContent.trim();
        if (titleText) {
          desktopTab.innerHTML = titleHTML;
          mobileOption.textContent = titleText; // Mobile select doesn't support HTML
          // Hide the paragraph in the form
          paragraph.style.display = 'none';
          extractedForms.add(index);
          return;
        }
      }
      
      // Check if form has any content loaded (not just empty)
      const hasContent = shopifyFormsEmbed?.shadowRoot?.querySelector('form, [class*="_form"]') || 
                        form.querySelector('form, [class*="_form"]');
      
      if (hasContent) {
        // Fallback: use generic name if form is loaded but no header found
        const fallbackTitle = 'Form ' + (index + 1);
        desktopTab.textContent = fallbackTitle;
        mobileOption.textContent = fallbackTitle;
        extractedForms.add(index);
      }
    });
  }
  
  // Initial extraction
  extractFormTitles();
  
  // Set up MutationObserver to watch for form content changes
  const formContainer = document.querySelector('.form-container');
  if (formContainer) {
    const observer = new MutationObserver((mutations) => {
      extractFormTitles();
      
      // Disconnect observer if all forms have been extracted
      if (extractedForms.size >= document.querySelectorAll('.form-container .contact-form').length) {
        observer.disconnect();
      }
    });
    
    observer.observe(formContainer, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  let currentFormID = 'form-index--1';
  
  function handleFormChange(formID, updateHash = true) {
    // Skip if already on this form
    if (currentFormID === formID) return;
    
    currentFormID = formID;
    
    const activeDesktopTab = document.querySelector("#form-type li.active");
    const newDesktopTab = document.querySelector(`#form-type li[data-form='${formID}']`);
    const activeForm = document.querySelector(".contact-form.active");
    const newForm = document.querySelector(`.contact-form#${formID}`);
    const mobileSelect = document.querySelector(".mobile-form-selector select");
    
    if (activeDesktopTab) activeDesktopTab.classList.remove("active");
    if (newDesktopTab) newDesktopTab.classList.add("active");
    
    if (activeForm) activeForm.classList.remove("active");
    if (newForm) newForm.classList.add("active");
    
    if (mobileSelect && mobileSelect.value !== formID) {
      mobileSelect.value = formID;
    }
    
    // Update URL hash
    if (updateHash) {
      const formNumber = formID.replace('form-index--', '');
      history.pushState(null, '', `#${formNumber}`);
    }
  }

  document.querySelectorAll("#form-type li").forEach(item => {
    item.addEventListener("click", () => handleFormChange(item.dataset.form));
  });

  document.querySelector(".mobile-form-selector select").addEventListener("change", (event) => {
    handleFormChange(event.target.value);
  });
  
  // Handle URL hash to show specific form
  function handleHashChange() {
    const hash = window.location.hash;
    if (hash && hash.match(/^#\d+$/)) {
      const formNumber = hash.substring(1); // Remove the # symbol
      const formID = `form-index--${formNumber}`;
      const formExists = document.querySelector(`.contact-form#${formID}`);
      
      if (formExists) {
        handleFormChange(formID, false); // Don't update hash when responding to hash change
      }
    }
  }
  
  // Check hash on page load
  handleHashChange();
  
  // Listen for hash changes
  window.addEventListener('hashchange', handleHashChange);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-register"]) return;
  try {
    
theme.waitForElement('#chRegForm #chMfHolder_accepts_email_marketing', 3000).then(function() {
  // Check the 'Accept Marketing' checkbox on load
  document.getElementById('ch_accepts_email_marketing_cb').checked = true;
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;

      // Set the recommended product label based on the skin quiz results
      document.dispatchEvent(new CustomEvent('refreshRecommendedProductsLabel'));
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
